import React, { useEffect, useState } from "react";
import styles from "./ErrorPage.module.css";

export default function ErrorPage() {
  const [glitchActive, setGlitchActive] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setGlitchActive(true);
      setTimeout(() => setGlitchActive(false), 200);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className={styles.errorContainer}>
      <div className={styles.stars}></div>
      <div className={styles.content}>
        <div className={styles.errorCode}>
          <span className={`${styles.codeDigit} ${glitchActive ? styles.glitch : ""}`}>
            5
          </span>
          <span className={`${styles.codeDigit} ${glitchActive ? styles.glitch : ""}`}>
            0
          </span>
          <span className={`${styles.codeDigit} ${glitchActive ? styles.glitch : ""}`}>
            3
          </span>
        </div>
        <h1 className={`${styles.title} ${glitchActive ? styles.glitch : ""}`}>
          СИСТЕМА НЕДОСТУПНА
        </h1>
        <p className={styles.subtitle}>
          Соединение с сервером потеряно
        </p>
        <div className={styles.statusGrid}>
          <div className={styles.statusItem}>
            <div className={styles.statusIndicator}></div>
            <span>Сервер недоступен</span>
          </div>
          <div className={styles.statusItem}>
            <div className={`${styles.statusIndicator} ${styles.statusError}`}></div>
            <span>Проверьте подключение</span>
          </div>
        </div>
        <button className={styles.retryButton} onClick={handleRetry}>
          <span className={styles.buttonText}>ПОВТОРИТЬ ПОДКЛЮЧЕНИЕ</span>
          <div className={styles.buttonGlow}></div>
        </button>
      </div>
      <div className={styles.scanlines}></div>
      <div className={styles.gridOverlay}></div>
    </div>
  );
}

